import React from "react";
import { FlatList, View } from "react-native";
import Accordion from "../../accordion/Accordion";
import { AccordionArrow, IconTokens } from "@voltmoney/schema";
const FAQScreenShortfall = ({ data }) => {
    const renderItem = ({ item, index }) => {
        return (React.createElement(View, null,
            React.createElement(Accordion, { title: item.title, description: item.description, icon: IconTokens.DownArrow, rightIcon: AccordionArrow.RIGHT, mainScreen: true, hideDivider: index === 3 ? true : false })));
    };
    return (React.createElement(View, { style: { paddingTop: 16 } }, React.createElement(FlatList, { data: data, renderItem: renderItem, keyExtractor: (item) => item.id })));
};
export default FAQScreenShortfall;
